import { render } from "./PartnerImage.vue?vue&type=template&id=33a655e8"
import script from "./PartnerImage.vue?vue&type=script&lang=js"
export * from "./PartnerImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__